import { RangeAddress } from 'shared/excel/rangeAddress';



export class NamedItem {

    constructor(item) {
        this.item = item;
    }

    get name() { return this.item.name; }
    get type() { return this.item.type; }
    get isRange() { return this.type === 'Range'; }


    toRangeAddress() {
        return new RangeAddress(this.item.value)
    }

}